import { Select } from 'antd';
import { type VFC, useMemo } from 'react';
import type { SelectProps } from 'antd/lib/select';
import { OutputTechnology } from '@enmon/commons/lib/tools';
import { outputTechnologyTranslated } from 'routes/portfolio/locations/const';
import { filterOption, filterSort } from '../utils';

export interface OutputTechnologiesSelectProps extends SelectProps<number> {
  onChange?: (value: number | null) => void;
}

export const OutputTechnologiesSelect: VFC<OutputTechnologiesSelectProps> = props => {
  const { onChange, ...propsToPass } = props;

  const outputTechnologiesOptions = useMemo(
    () =>
      Object.values(OutputTechnology).map(value => ({
        label: outputTechnologyTranslated[value],
        value,
      })),
    [],
  );

  return (
    <Select
      allowClear
      showSearch
      className="w-100"
      filterOption={filterOption}
      filterSort={filterSort}
      maxTagTextLength={20}
      options={outputTechnologiesOptions}
      placeholder="Select technologies"
      onChange={onChange}
      onClear={() => onChange?.(null)}
      {...propsToPass}
    />
  );
};
